import * as React from 'react';
import { Button, Form, Spinner } from "react-bootstrap";
import './LifeChangeBankingDetailsDebicheck.css';

export interface LifeChangeBankingDetailsDebicheckProps {
    debitOrderDate: string;
    debitOrderDateDay: string;
    premium: string;
    bankName: string;
    accountNumber: string;
    saving: boolean;
    error: any;
    success: any;
    emitHandleContinue;
}

interface State {
    debicheckAuthenticationType: string|null;
    authorize: boolean|null;
    authority: boolean|null;
}

export class LifeChangeBankingDetailsDebicheck extends React.Component<LifeChangeBankingDetailsDebicheckProps, State> {
    constructor(props: LifeChangeBankingDetailsDebicheckProps) {
        super(props);

        this.state = {
            debicheckAuthenticationType: null,
            authorize: false,
            authority: false,
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.handleDebicheckAuthenticationTypeChange = this.handleDebicheckAuthenticationTypeChange.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
    }

    async handleChange(e: any) {
        const value: string = e.target.value;
        const key: string = e.target.name;

        await this.setState({ ...this.state, [key]: value });
    }

    async handleCheckChange(e: any) {
        this.setState(() => ({
            ...this.state,
            [e.target.name]: !this.state[e.target.name],
        }));
        e.stopPropagation();
    }
   
    handleDebicheckAuthenticationTypeChange(e: any) {
        const key = e.target.name;
        const value = e.target.value;
        this.setState({
            ...this.state,
            [key]: value
        });
    }

    handleContinue(e: any) {
        this.props.emitHandleContinue({
            debicheckAuthenticationType: this.state.debicheckAuthenticationType,
        });
    }
    
    public render() {
        return (
            <>
                <div className="debicheck__authentication-type col-12 nopa">
                    <div className="row noma">
                        <div className="change-banking-details-check-box-row col-6 nopa">
                            <input onChange={this.handleDebicheckAuthenticationTypeChange} className="change-banking-details-check col-1 nopa" type="radio" radioGroup='LinkPolicy' id='debicheckAuthenticationTypeDelayed' name='debicheckAuthenticationType' value="debicheckDelayed"></input>
                            <label htmlFor="debicheckAuthenticationTypeDelayed" className="col-10 nopa change-banking-details-radio-text">Sameday debicheck</label>
                        </div>
                        <div className="change-banking-details-check-box-row col-6 nopa">
                            <input onChange={this.handleDebicheckAuthenticationTypeChange} className="change-banking-details-check col-1 nopa" type="radio" radioGroup='LinkPolicy' id='debicheckAuthenticationTypeImmediate' name='debicheckAuthenticationType' value="debicheckImmediate"></input>
                            <label htmlFor="debicheckAuthenticationTypeImmediate" className="col-10 nopa change-banking-details-radio-text">Immediate debicheck</label>
                        </div>
                    </div>
                </div>
                <hr className="noma nopa change-banking-details__hr" />
                <div className="change-banking-details__disclosures">
                    <div className="">
                        <Form.Group className="d-flex" onChange={this.handleChange}>
                            <label htmlFor="authorize">Do you confirm an <b className="change-banking-details__disclosures__bold">amount of R{this.props.premium}</b> will be collected <b className="change-banking-details__disclosures__bold">via debit order on the {this.props.debitOrderDate}</b>, and thereafter on day {this.props.debitOrderDateDay} of each month (if the debit date falls on a non-banking day, we'll collect your premium on the last banking day prior to the debit date)</label>
                            <div className="change-banking-details__disclosures-input-block">
                                <Form.Check onChange={this.handleCheckChange} id="authorize" name="authorize" className="change-debit-order__switch" type="switch" />
                                <p className="change-banking-details__disclosures-hint">
                                    {this.state.authorize && <span>Yes</span>
                                    || <span>No / Yes</span> }
                                </p>
                            </div>
                        </Form.Group>
                    </div>
                    <div className="">
                        <Form.Group className="d-flex" onChange={this.handleChange}>
                            <label htmlFor="authority">Do you confirm you have authority over <b className="change-banking-details__disclosures__bold">{this.props.bankName} account number {this.props.accountNumber}</b> and hereby give permission for it to be debited in terms of the policy and that you agree to allow for tracking of dates to match with cash flow (at no additional cost to yourself.)</label>
                            <div className="change-banking-details__disclosures-input-block">
                                <Form.Check onChange={this.handleCheckChange} id="authority" name="authority" className="change-debit-order__switch" type="switch" />
                                <p className="change-banking-details__disclosures-hint">
                                    {this.state.authority && <span>Yes</span>
                                    || <span>No / Yes</span> }
                                </p>
                            </div>
                        </Form.Group>
                    </div>
                </div>
                <hr className="noma nopa change-banking-details__hr" />
                <div className="life-change-banking-details-debicheck__footer">
                    <>
                        <Button disabled={this.state.debicheckAuthenticationType == null || this.state.authorize != true || this.state.authority != true} onClick={this.handleContinue} className="life-change-banking-details-footer__validate btn btn-solid-red mt-3">
                            {!this.props.saving && <>Continue</>
                                ||
                                <Spinner className="d-block mx-auto" animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>}
                        </Button>
                        {this.props.error && <>
                            {this.props.error && <p className="mt-3 life-change-banking-details-footer__error-message">{this.props.error}</p>}
                        </>}
                        <div className="col-12 schedule-special-debit__secure life-change-banking-details-footer__disclosure text-center row justify-content-center align-items-center flex-nowrap">
                            <div className="col-auto">
                                <img className="d-inline-block" src="./Images/LifeInsurance/icon-lock.png" />
                            </div>
                            <div className="col-auto">
                                <p className="d-inline-block text-left mb-0">
                                    <strong>Secure connection</strong>. Your info's encrypted, which means it's totally safe with us
                                </p>
                            </div>
                        </div>
                    </>
                </div>
            </>
        )
    }
}
